import React from 'react';

const EnvDebug = () => {
  // Show debug info when URL has ?debug=env
  const showDebug = window.location.search.includes('debug=env');
  
  if (!showDebug) {
    return null;
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: 10, 
      right: 10, 
      background: 'rgba(0,0,0,0.9)', 
      color: 'white', 
      padding: '15px', 
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '400px',
      borderRadius: '8px',
      fontFamily: 'monospace'
    }}>
      <h4 style={{ margin: '0 0 10px 0', color: '#00ff00' }}>🔍 Environment Debug</h4>
      <div><strong>NODE_ENV:</strong> {process.env.NODE_ENV || 'undefined'}</div>
      <div><strong>API_URL:</strong> {process.env.REACT_APP_API_URL || '❌ MISSING'}</div>
      <div><strong>COGNITO_DOMAIN:</strong> {process.env.REACT_APP_COGNITO_DOMAIN || '❌ MISSING'}</div>
      <div><strong>COGNITO_CLIENT_ID:</strong> {process.env.REACT_APP_COGNITO_CLIENT_ID || '❌ MISSING'}</div>
      <div><strong>REDIRECT_URI:</strong> {process.env.REACT_APP_COGNITO_REDIRECT_URI || '❌ MISSING'}</div>
      <div><strong>GOOGLE_CLIENT_ID:</strong> {process.env.REACT_APP_GOOGLE_CLIENT_ID || '❌ MISSING'}</div>
      <div style={{ marginTop: '10px', fontSize: '10px', opacity: 0.7 }}>
        Add ?debug=env to URL to show this panel
      </div>
    </div>
  );
};

export default EnvDebug;
